import { KidsAddCoverArt } from "../../ls2kids/addCoverArt";
import { LibraryThing } from "../widget/LibraryThingWidget";

export const AddCoverArt = (function ( $ ) {
	var isTrident7 = /Trident\/7\.0;/i.test( navigator.userAgent );
	var versions = navigator.userAgent.match( /rv:(\d+)\.(\d+)/i );
	var isVersion11 = false;

	if( isTrident7 && versions.length == 3 ) {
		isVersion11 = parseInt( versions[1], 10 ) == 11;
	}
	$.fn.addCoverArt = function ( requestType, resources, index, displayDummyJacket, tryToResize, callback, showFormat, randomizeCoverArt, doNotsetTopMargin ) {
		showFormat = (showFormat === undefined) ? true : showFormat;
		randomizeCoverArt = ( randomizeCoverArt === undefined ) ? false : randomizeCoverArt;

		var resource = resources[index];

		if( parseInt( resource.rtype, 10 ) == 2 ) {
			resource.format = "RSS";
		} 
		// else if( parseInt( resource.rtype, 10 ) == 3 ) {
		// 	return;
		// }

		if( showFormat && resource.format && resource.format.length > 0 ) {
			$( this ).parent().append( '<div class="format ' + resource.format + '">' + resource.format + '</div>' );
		}

		var format = 'book';
		var imgClass = requestType.toLowerCase();
		var imgURL = LibraryThing.getBookjacketUrl( requestType, resource );
		var bgURL = "images/bookjackets/" + format + "/" + requestType.toLowerCase() + ".png";

		if( parseInt( resource.rtype, 10 ) == 2 ) {
			imgURL = bgURL = "images/bookjackets/rss/" + requestType.toLowerCase() + ".png";
			if( resource.content ) {
				var urls = resource.content.match( /<img src=(.+?[.jpg|.gif|.png]")/g ) || [];
				if( urls ) {
					$.each( urls, function ( index, tempUrl ) {
						if( tempUrl.length > 0 &&
							tempUrl.indexOf( "feedburner" ) == -1 &&
							tempUrl.indexOf( "spacer.gif" ) == -1 &&
							tempUrl.indexOf( "a2.img" ) == -1 &&
							tempUrl.indexOf( "a2t.img" ) == -1 &&
							tempUrl.indexOf( "mf.gif" ) == -1 ) {
							tempUrl = tempUrl.replace( "<img src=", "" ).replace( /"/g, "" );
							imgURL = tempUrl;
						}
					} );
				}
			}
		}

		var adjustImageMarginTop = function ( img, tryToResize, width, height, outerDivWidth, outerDivHeight ) {
			if( tryToResize ) {
				var imgWidth = width;
				var imgHeight = height;

				if( imgWidth > outerDivWidth || imgHeight > outerDivHeight ) {
					var wRatio = imgWidth / outerDivWidth;
					var hRatio = imgHeight / outerDivHeight;
					var ratio = Math.max( wRatio, hRatio );
					imgWidth = Math.floor( imgWidth / ratio );
					imgHeight = Math.floor( imgHeight / ratio );
					img.width(imgWidth);
					img.height(imgHeight);
				}
			}

			var parent = $( img.parentNode );
			var parentHeight = parent.height();
			var heightOffset = (parentHeight - height) / 2;
			if( heightOffset > 0 && !doNotsetTopMargin ) {
				parent.css( "marginTop", heightOffset + "px" );
			}
			parent.addClass( "done" );
			img.onload = null;
		};

		var spinner;
		var stopSpinner = function () {
			spinner.spin( false );
		};

		return this.each( function (i, element) {
			(function ( $this ) {
				spinner = $this;
				if( window.isIE8 == false ) {
					spinner.spin( "small" );
				}

				//Using kids addCoverArt at this point, and modifying after
				KidsAddCoverArt.load( $this, {
					requestType:        requestType,
					resources:          resources,
					index:              index,
					displayDummyJacket: displayDummyJacket,
					colors:             ['gray'], // more colors are available, and are used in kids
					callback:           function () {
						var resource = resources[index];
						var image = $this.find( "img" );
						image.css( "opacity", 1 );
						image.attr('alt', resource.shortTitle)

						// Determine parents positioning.  Set to relative if not relative or absolute;
						var pos = $this.css( 'position' );
						if( pos != 'relative' && pos != 'absolute' ) {
							$( this ).css( 'position', 'relative' );
						}

						var fireCallback = function () {
							if( callback !== undefined && callback !== null ) {
								var cb = callback;
								callback = null;
								// delete callback not supported in strict mode
								if( cb ) {
									cb();
								}
							}
						};

						var outerDivWidth = parseInt( $this.width(), 10 ) - 10;
						var outerDivHeight = $this.height();
						var width = image.width();
						var height = image.height();
						var orientation = width > height ? 'landscape':'portrait';
                        image.addClass(orientation);

                        adjustImageMarginTop( image, tryToResize, width, height, outerDivWidth, outerDivHeight );
						// adjustImageMarginTop( this, tryToResize, width, height, outerDivWidth, outerDivHeight );
						stopSpinner();
						fireCallback();
					}
				} );
			})( $( element ) );
		} )
	};

	return {};
})( jQuery );
